import { type CSSProperties } from 'react';
import {
  AUTOMATIC_PICKLIST_EXECUTIONS_PAGE_URL,
  AUTOMATIC_REPLENISHMENT_EXECUTIONS_PAGE_URL,
  CLIENT_FEEDBACK_RESULTS_PAGE_URL,
  INVENTORY_OPERATION_DETAIL_PAGE_URL,
  PICKLIST_DETAIL_PAGE_URL,
  POINT_OF_SALE_EDIT_PAGE_URL,
  PRODUCT_EDIT_PAGE_URL,
  SALES_ORDER_DETAIL_PAGE_URL,
  STOCK_CONTROL_PRODUCT_PAGE_URL,
  TERMINAL_EDIT_PAGE_URL,
} from '@/api/core/links';
import { type NotificationType } from '@/app/components/feedback/SystemNotification';
import { NotificationSourceType } from '@/app/enums/NotificationSourceType';
import { type NotificationDto } from '@/app/models/NotificationDto';

type SourceUrlBuilder = (id: string) => string;

const SOURCE_URL_BY_TYPE: Partial<Record<NotificationSourceType, SourceUrlBuilder>> = {
  [NotificationSourceType.AUTOMATIC_REPLENISHMENT]: AUTOMATIC_REPLENISHMENT_EXECUTIONS_PAGE_URL,
  [NotificationSourceType.AUTOMATIC_PICKLIST]: AUTOMATIC_PICKLIST_EXECUTIONS_PAGE_URL,
  [NotificationSourceType.SALES_ORDER]: SALES_ORDER_DETAIL_PAGE_URL,
  [NotificationSourceType.PICKLIST]: PICKLIST_DETAIL_PAGE_URL,
  [NotificationSourceType.WAREHOUSE_TASK]: INVENTORY_OPERATION_DETAIL_PAGE_URL,
  [NotificationSourceType.POINT_OF_SALE]: POINT_OF_SALE_EDIT_PAGE_URL,
  [NotificationSourceType.TERMINAL]: TERMINAL_EDIT_PAGE_URL,
  [NotificationSourceType.CLIENT_FEEDBACK]: CLIENT_FEEDBACK_RESULTS_PAGE_URL,
  [NotificationSourceType.PRODUCT]: PRODUCT_EDIT_PAGE_URL,
  [NotificationSourceType.PRODUCT_STOCK]: STOCK_CONTROL_PRODUCT_PAGE_URL,
};

/** A tela onde a notificação se resolve: a da origem ou, sem ela, a do PDV. */
export const getNotificationSourceUrl = ({ source_type, source_id, point_of_sale_id }: NotificationDto) => {
  const sourceUrl = source_type && source_id ? SOURCE_URL_BY_TYPE[source_type.value]?.(source_id) : undefined;
  if (sourceUrl) return sourceUrl;
  return point_of_sale_id ? POINT_OF_SALE_EDIT_PAGE_URL(point_of_sale_id) : undefined;
};

/** O comunicado não abre tela: tem aba e modal próprios. */
export const isAnnouncementNotification = ({ source_type }: NotificationDto): boolean =>
  source_type?.value === NotificationSourceType.ANNOUNCEMENT;

/** O link do resumo vem absoluto, para servir ao e-mail; no app, basta o caminho. */
export const getSummaryLinkPath = (link: string) => {
  const { pathname, search } = new URL(link, window.location.origin);
  return pathname + search;
};

/** Mesma convenção do sino: resolvida vence, depois a urgente; o resto é informativo. */
export const notificationToastType = (resolvedDate?: string, urgent?: boolean): NotificationType => {
  if (resolvedDate) return 'success';
  return urgent ? 'error' : 'info';
};

/** Limita o texto a `lines` linhas, cortando o excedente. */
export const lineClampStyle = (lines: number): CSSProperties => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
});
